export default __webpack_public_path__ + "static/media/consultation.b4a64465.png";